module.exports = __webpack_public_path__ + "img/us5.4540ea40.png";